import { Apollo, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import { pluck } from 'rxjs/operators';
const statesQuery = gql`query get_states{
  states{
    id
    name
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class StatesService {

  constructor(private apollo: Apollo) { }

  getStates(){
    return this.apollo.use('external').query({
      query: statesQuery
    }).pipe(pluck('data', 'states'));
  }
}
